/*
 * Copyright 2026 NXGN Management, LLC. All Rights Reserved.
 */

import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { REST_CONSTANTS } from "../utils/data.rest.constants";
import { MerchantApplicationRequest, OnboardingProfiles } from "../models/merchant-application";

@Injectable({
  providedIn: "root"
})
export class OnboardingService {
  constructor(private http: HttpClient) {}

  submitMerchantApplication(application: MerchantApplicationRequest): Observable<unknown> {
    const url = `${REST_CONSTANTS.MERCHANT_BASE_URL_V9}/gp/onboarding/applications`;
    return this.http
      .post<unknown>(url, application, { headers: REST_CONSTANTS.JSON_HEADER })
      .pipe(catchError(OnboardingService.handleError));
  }

  getProfiles(): Observable<OnboardingProfiles> {
    const url = `${REST_CONSTANTS.MERCHANT_BASE_URL_V9}/gp/onboarding/profiles`;
    return this.http
      .get<OnboardingProfiles>(url, { headers: REST_CONSTANTS.JSON_HEADER })
      .pipe(catchError(OnboardingService.handleError));
  }

  private static handleError(error: HttpErrorResponse) {
    return throwError(error);
  }
}
